var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 13.3333V10",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 6.66667H10.0083",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo20);
export default __webpack_public_path__ + "static/media/icon-info-20.23785bbed5f764a675c31a2e4a5511a5.svg";
export { ForwardRef as ReactComponent };